// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'tachyons'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import '@fortawesome/fontawesome/styles.css'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import brands from '@fortawesome/fontawesome-free-brands'
import {faEdit, faQuestionCircle} from '@fortawesome/fontawesome-free-solid'
import store from './store'
import Toasted from 'vue-toasted'
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate'
import i18n from './translator'
import timeFilter from './filters/time'
import currencyFilter from './filters/currency'
import VueCarousel from 'vue-carousel'
import SocialSharing from 'vue-social-sharing'
import VueMq from 'vue-mq'
import VueLoading from 'vuex-loading'
import VueClipboards from 'vue-clipboards'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import VTooltip from 'v-tooltip'

// Auth0 Plugin
import { Auth0Plugin } from './auth'
import { domain, clientId } from './auth_config.json'

import {
  BContainer,
  BRow,
  BCol,
  BIcon,
  BIconPlayCircle,
  BButton,
  BTable,
  BTooltip
} from 'bootstrap-vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Row, Column } from 'vue-grid-responsive'
import './assets/styles.css'
import CKEditor from '@ckeditor/ckeditor5-vue2'

Vue.component('row', Row)
Vue.component('column', Column)
Vue.component('b-container', BContainer)
Vue.component('b-row', BRow)
Vue.component('b-col', BCol)
Vue.component('b-button', BButton)
Vue.component('BIcon', BIcon)
Vue.component('BIconPlayCircle', BIconPlayCircle)
Vue.component('b-table', BTable)
Vue.component('b-tooltip', BTooltip)

/**
 * @see https://github.com/FortAwesome/vue-fontawesome/issues/22
 * @type {{autoAddCss: boolean}}
 */
fontawesome.config = {
  autoAddCss: false
}

fontawesome.library.add(brands, faEdit, faQuestionCircle)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.filter('time', timeFilter)
Vue.filter('currency', currencyFilter)

Vue.use(VueResource)

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

Vue.use(Toasted, {
  position: 'top-center',
  duration: 5000,
  singleton: true
})

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity
  }
})

Vue.use(VModal, {dialog: true})
Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(VueCarousel)
Vue.use(SocialSharing)
Vue.use(VueLoading)
Vue.use(VueClipboards)

Vue.use(VTooltip)
Vue.use(CKEditor)

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    // id: 'UA-93769421-4',
    id: 'UA-93769421-1',
    router
  })
  Vue.use(VueGtm, {
    vueRouter: router
  })
}

Vue.http.interceptors.push((request, next) => {
  request.headers.set('access-token', localStorage.getItem('token'))
  request.headers.set('Content-Language', i18n.locale)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  vueLoading: new VueLoading({useVuex: true, moduleName: 'loading', registerComponents: false}),
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js